import React, {Component} from 'react';
import processIcon from './process.png'
import NormalButton from "../normalButton";
import BaseComponent from "../../../../base/BaseComponent";
import {HistoryList} from "../history/history";
import moment from 'moment';
import onClickOutside from "react-onclickoutside";
import {getColorByState} from "../../../components/colorByState/colorByState"

class Process extends BaseComponent {

    state = {
        list : [],
        listVisible: false
    };

    dataType = "website";
    constructor(props) {
        super(props);
        if(this.props.editor && this.props.editor.dataType){
            this.dataType = this.props.editor.dataType
        }
    }

    componentDidMount() {
        let editorId = this.props.dynamicParams.editorId;
        let oldId = this.props.dynamicParams.oldId;
        this.getHistoryData(editorId || oldId,!!editorId);
    }

    componentWillReceiveProps(nextProps, nextContext) {
        let editorId = this.props.dynamicParams.editorId;
        let oldId = this.props.dynamicParams.oldId;
        let editorId2 = nextProps.dynamicParams.editorId;
        let oldId2 = nextProps.dynamicParams.oldId;
        if( editorId!=editorId2 || oldId!=oldId2) {
            this.getHistoryData(editorId2 || oldId2,!!editorId2);
        }
    }

    getHistoryData(editorId,reload=true){
        if(editorId&&editorId.length>1){
            this.request({
                url : "/cm-sites-sys/process/getProcessHistory",
                body:{bizKey:`${editorId}`},
                callBack: async (list)=>{
                    if(list && list.length) {
                        this.setState({list})
                    } else {
                        reload && this.reloadHistoryData(editorId)
                    }
                },serverVerify:{
                    serverErrorCallBack:async ()=>{
                        reload && this.reloadHistoryData(editorId)
                    },
                    isShowErrorMsg:false
                }
            })
        }
    }

    // 网站稿件没有查到流程记录时，尝试通过投稿id查询流程记录
    reloadHistoryData = async (editorId) => {
        if(this.props.dynamicParams && this.props.dynamicParams.oldId && this.props.dynamicParams.oldId!=editorId) {
            // 存在传递过来的投稿id时直接查询
            this.getHistoryData(this.props.dynamicParams.oldId,false)
        }else if(this.props.dynamicParams && this.props.dynamicParams.findOldUuid) {
            // 可以通过接口查询投稿id时
            let oldId = await this.props.dynamicParams.findOldUuid({id:editorId});
            // 查到投稿id后进行验证是否可用：1、投稿id存在；2、投稿id和传递过来的投稿id不一样；3、投稿id和当前稿件id不一致
            if(
                oldId
                && oldId!=this.props.dynamicParams.oldId
                && oldId!=this.props.dynamicParams.editorId
            ) {
                this.getHistoryData(oldId,false)
            }
        }
    };

    render() {
        return (
            <span style={{position:"relative"}}>
                <NormalButton onClick={()=>{
                    this.setState({
                        listVisible:!this.state.listVisible
                    })
                }} style={this.props.style} icon={processIcon} text={"流程记录"}/>
                <HistoryList
                    itemComponentClick={(editor, item) => {
                        editor.setContent(item.processData.data.content);
                        editor.setCurrentInformation(item.processData.data);
                    }}
                    itemComponent={ProcessHistoryItem}
                    itemComponentStyle={{height:120}}
                    title={"流程记录"}
                    editor={this.props.editor}
                    visible={this.state.listVisible}
                    data={this.state.list}
                    diffOnClick={()=>{
                        let id = this.props.dynamicParams.editorId;
                        if(!id){
                            id = this.props.dynamicParams.oldId;
                        }
                        window.openPage({
                            url: `/cm-sites/pms/framereact/index.html#/view/htmldiff/htmldiff/process/${this.dataType}/${id}`,
                            params: this.state.list
                        });
                        // window.open(`#/view/htmldiff/htmldiff/process/${this.dataType}/${this.props.dynamicParams.editorId}`)
                    }}
                />
            </span>
        );
    }
    handleClickOutside = (evt) => {
        this.setState({
            listVisible: false
        })
    };
}

class ProcessHistoryItem extends Component{

    static defaultProps = {
        style:{},
        className:"historyItem",
        onClick:()=>{}
    };

    render (){
        let {item, prevItem} = this.props;
        let startTime = moment(item.createTime).format("yyyy-MM-DD HH:mm");
        let endTime = !prevItem?<span style={{color:"red"}}>待处理</span>:moment(prevItem.createTime).format("yyyy-MM-DD HH:mm");
        if(item.destroy || item.done || item.revert) {
            endTime = moment(item.dbUpdateTime).format("yyyy-MM-DD HH:mm")
        }
        let hideCandidateNames = (prevItem && prevItem.createTime) || !(item && item.candidateNames && item.candidateNames.length);
        let candidateNames = hideCandidateNames?"":`候选人：${item.candidateNames.join("，")}`;
        let backgroundColor = getColorByState(item.taskName);
        return (
            <div onClick={() => {
                this.props.onClick()
            }} className={this.props.className} style={{
                borderLeft: '3px solid #24B481',
                borderRadius: 3,
                padding: 10,
                borderColor: this.props.color, ...this.props.style
            }}>
                <table cellPadding={0} cellSpacing={0} border={0}
                       width={"100%"} height={"100%"}>
                    <tbody>
                    <tr>
                        <td valign={"middle"}>
                            <div className={"plan-pointer"} style={{
                                textAlign: "right",
                                marginRight: 15,
                                paddingLeft: 5,
                                float: "right",
                                display: "flex",
                            }}>
                                <div style={{
                                    width: 10,
                                    height: 10,
                                    marginRight: 5,
                                    borderRadius: "50%",
                                    background: backgroundColor,
                                    alignSelf: "center"
                                }}></div>
                                <span className={"text-pointer"} style={{maxWidth: "100px"}} title={item.taskName}>{item.taskName}</span>
                            </div>
                            <div className={"plan-pointer text-pointer"} title={item.operatorName || "佚名"}
                                 style={{float: "left", paddingLeft: 5, width: "115px", maxHeight: "125px"}}>{item.operatorName || "佚名"}</div>
                        </td>
                    </tr>
                    <tr>
                        <td valign={"middle"}>
                            <div className={"plan-pointer"}
                                 style={{marginRight: 20, paddingLeft: 5, color: "#ada4a4"}}>开始时间：{startTime}</div>
                        </td>
                    </tr>
                    <tr>
                        <td valign={"middle"}>
                            <div className={"plan-pointer"}
                                 style={{marginRight: 20, paddingLeft: 5, color: "#ada4a4"}}>结束时间：{endTime}</div>
                        </td>
                    </tr>
                    {
                        hideCandidateNames ? null : (
                            <tr>
                                <td valign={"middle"}>
                                    <div className={"plan-pointer text-pointer"} title={candidateNames} style={{
                                        marginRight: 20,
                                        paddingLeft: 5,
                                        color: "#ada4a4",
                                        width: 240
                                    }}>{candidateNames}</div>
                                </td>
                            </tr>
                        )
                    }
                    </tbody>
                </table>
                <style>{`
                .historyItem:hover{
                    background: #ccd9eb !important
                }
            `}</style>
            </div>
        )
    }
}
export default onClickOutside(Process);